<template>
  <div style="padding-bottom:20px">
    <div class="container deal-detail">
      <div class="first-party">
        <van-cell title="甲方名称" value="广东哈弗石油能源股份有限公司" />
        <van-cell
          title="乙方(代理商)"
          :value="agreementContent.partyABusinessLicenseName"
        />
        <div class="module-title">丙方信息</div>
        <van-cell title="丙方(门店)" :value="agreementContent.partyBName" />
        <van-cell title="负责人姓名" :value="agreementContent.partyBRealName" />
        <van-cell title="负责人手机号" :value="agreementContent.partyBPhone" />
        <van-cell
          title="证件类型"
          :value="agreementContent.idType === 1 ? '身份证' : '营业执照'"
        />
        <van-cell title="证件号码" :value="agreementContent.idNo" />
        <van-cell title="广告位置" :value="agreementContent.advertAddress" />
        <van-cell title="完成时间" :value="agreementContent.finishAt" />
      </div>
      <div class="module-title">丙方义务</div>
      <div class="second-party">
        <div>
          <span>连续经营哈弗润滑油不少于</span>
          <span style="color:red">{{
            agreementContent.minOperationYears
          }}</span>
          <span>年</span>
        </div>
        <div>
          <span>进货哈弗产品总价值不低于</span>
          <span style="color:red">{{
            agreementContent.minPurchaseValue / 10000
          }}</span>
          <span>万元</span>
        </div>
        <div>
          <span>首批进货总价值不低于</span>
          <span style="color:red">{{
            agreementContent.firstPurchaseValue
          }}</span>
          <span>元</span>
        </div>
        <div>
          <span>首批进货最迟截止日期</span>
          <span style="color:red">{{
            agreementContent.firstLatestPurchaseDate
          }}</span>
        </div>
      </div>
      <div class="module-title">广告报销方式</div>
      <div v-for="(item, index) in refundArr" :key="index" class="refund">
        丙方<span style="color:black" v-if="index == 0">首批</span>
        <span style="color:black" v-if="index != 0">再次</span>进货<span
          style="color:black"
          v-if="index != 0"
          >并累计</span
        >满
        <span>
          {{
            item.stockPrice > 10000
              ? item.stockPrice / 10000 + "万"
              : item.stockPrice
          }} </span
        >元时,甲方<span style="color:black" v-if="index != 0">再</span>报销
        <span>{{ item.refund }}</span> 元
      </div>
      <router-link
        class="agreement-detail"
        :to="{ name: 'AdDetail', query: { id: adId } }"
      >
        广告内容
      </router-link>
      <router-link class="agreement-detail" to="/shop/agreementDetail">
        查看协议完整内容
      </router-link>
      <p
        class="resend-message"
        v-if="agreementContent.status == 0"
        @click="resendMessage"
      >
        <span style="color:black">门店没收到确认信息？</span>点击此处重发
      </p>
      <div
        class="module-title"
        v-if="agreementContent.status > 6 && agreementContent.status !== 9"
      >
        公司核价
      </div>
      <div v-if="agreementContent.status > 6 && agreementContent.status !== 9">
        <div v-for="(item, index) in adContents" :key="index" class="pricing">
          <div>第{{ index + 1 }}份广告核价{{ item.price }}元</div>
          <van-image
            width="88"
            height="88"
            fit="contain"
            :src="$imgPath + item.pricingImg"
            @click="previewImg"
          />
        </div>
      </div>
      <!-- <div class="module-title" v-if="agreementContent.status !== 9">
        上传进货凭证
      </div>
      <div class="uploader-img" v-if="agreementContent.status !== 9">
        <van-grid :border="false" :column-num="3">
          <van-grid-item v-for="(item, index) in certificateList" :key="index">
            <van-image
              fit="contain"
              :src="$imgPath + item.path"
              @click="previewImg"
            />
          </van-grid-item>
          <van-grid-item>
            <van-uploader
              v-model="fileList"
              multiple
              :max-count="1"
              :after-read="afterRead"
              :before-delete="beforeDelete"
              :before-read="beforeRead"
            />
          </van-grid-item>
        </van-grid>
      </div> -->
      <!-- <van-button
        v-if="agreementContent.status !== 9"
        type="primary"
        @click="handlerSubmit"
        :loading="subStatus"
        loading-text="提交中"
        >提交</van-button
      > -->
    </div>
  </div>
</template>
<script>
import { Dialog } from "vant";
import * as imageConversion from "image-conversion";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      agreementContent: "",
      adContents: [],
      refundArr: [],
      fileList: [],
      certificateImg: "",
      title: "",
      type: "",
      certificateList: [],
      subStatus: false,
      adId: ""
    };
  },
  created() {
    this.adId = this.$route.query.id;
    this.getDetail();
    // this.getCertificate();
  },
  methods: {
    // 广告详情
    getDetail() {
      this.$api.adDetails(this.$route.query.id).then(res => {
        // console.log("广告详情: ", res);
        res = res.result;
        this.agreementContent = res.apply;
        this.adContents = res.contents;
        this.refundArr = JSON.parse(this.agreementContent.reimbursementMethod);
        sessionStorage.setItem("apply", JSON.stringify(this.agreementContent));
      });
    },
    // 上传图片前
    beforeRead(file) {
      return new Promise(resolve => {
        const isLt2M = file.size / 1024 < 900;
        if (isLt2M) {
          resolve(file);
        } else {
          imageConversion.compressAccurately(file, 900).then(res => {
            let files = new window.File([res], file.name, {
              type: file.type
            });
            resolve(files);
          });
        }
      });
    },
    //图片上传
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      let content = file.file;
      let data = new FormData();
      data.append("img", content);
      this.$api
        .uploadImg(data)
        .then(res => {
          // console.log(res);
          file.status = "done";
          file.message = "上传成功";
          this.certificateImg = res.url;
          this.title = res.title;
          this.type = res.type;
        })
        .catch(err => {
          console.log(err);
          this.fileList.splice(this.fileList.length - 1, 1);
          this.$toast("上传超时,请再次尝试");
        });
    },
    // 图片删除
    beforeDelete(file, detail) {
      this.fileList.splice(detail.index, 1);
      this.certificateImg = "";
      this.title = "";
      this.type = "";
    },
    //获取进货凭证
    getCertificate() {
      this.$api.getCertificate(this.$route.query.id).then(res => {
        // console.log(res.result);
        this.certificateList = res.result;
      });
    },
    // 提交
    handlerSubmit() {
      this.subStatus = true;
      if (this.agreementContent.status < 7) {
        this.$toast("请等待公司核价后上传");
        this.subStatus = false;
        return false;
      }
      if (this.certificateImg.trim() === "") {
        this.$toast("请上传凭证");
        this.subStatus = false;
        return false;
      }
      this.$api
        .certificate({
          advertApplyId: this.$route.query.id,
          mediaType: this.type,
          name: this.title,
          path: this.certificateImg
        })
        .then(res => {
          if (res.code === 0) {
            this.subStatus = false;
            Dialog.alert({
              title: "提示",
              message: "已提交",
              confirmButtonText: "关闭"
            }).then(() => {
              // this.$router.go(0);
              this.fileList = [];
              this.getCertificate();
            });
          } else {
            this.subStatus = false;
            Dialog.alert({
              title: "提示",
              message: "提交失败,请检查",
              confirmButtonText: "关闭"
            });
          }
        });
    },
    //预览图片
    previewImg(e) {
      ImagePreview({
        images: [e.srcElement.src],
        closeable: true
      });
    },
    // 重发确认信息
    resendMessage() {
      this.$api.resendMessage(this.adId).then(res => {
        // console.log("重发确认信息:", res);
        if (res.code === 0) {
          Dialog.alert({
            title: "提示",
            message: "已发送短信给门店",
            confirmButtonText: "关闭"
          });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.deal-detail {
  padding-top: 10px;

  .module-title {
    padding: 5px 0;
    background-color: #eaeaea;
  }

  .second-party {
    div {
      padding: 10px 20px;
      text-align: left;
      font-size: 14px;
    }
  }

  .agreement-detail {
    display: block;
    margin-bottom: 10px;
    font-size: 14px;
  }

  .resend-message {
    font-size: 14px;
    color: #07c160;
  }

  .refund {
    padding: 10px 20px;
    text-align: left;
    font-size: 14px;

    span {
      color: red;
    }
  }

  .uploader-img {
    display: flex;
    align-items: center;
    text-align: left;
  }

  .pricing {
    padding: 10px 0;
  }
}

.van-cell {
  padding: 10px 20px;
}

.van-cell__title,
.van-cell__value {
  text-align: left;
}
</style>
<style lang="scss">
.deal-detail {
  .van-uploader__upload {
    margin: 0;
  }

  .van-dialog__message {
    font-size: 20px;
  }
}
</style>
